import { useSelector } from 'react-redux';

import { rootReducer } from '~/models/reducers';

const useReduxState = () => useSelector((state: rootReducer) => state);

export default useReduxState;
